var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLaurelsStar = function SvgLaurelsStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9B8D52",
    fillRule: "evenodd",
    d: "M1.873 6.22c-.106.28-.161.67-.563.232-.685-.748-.15-2.164-.113-2.154 0 0 .667.767.73 1.374.028.28 0 .275-.054.549",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#B4A97D",
    fillRule: "evenodd",
    d: "M4.61 4.1c-.062.028-.562.363-1.192.119-.05-.02-.288-.112.233-.638.504-.51 1.863-.47 1.84-.371-.071.298-.8.831-.882.89M2.96 13.512c-.027-.013-.387-.128-.96-.616-.25-.213.88-.275.959-.28.912-.05 1.432.726 1.302.79-.736.362-1.147.145-1.302.106",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#9B8D52",
    fillRule: "evenodd",
    d: "M4.135 2.692c-.055.106-.163.507-.78.776-.128.055-.485-.742.203-1.61.045-.055.623-.785.666-.59.132.612-.059 1.313-.089 1.424",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#B4A97D",
    fillRule: "evenodd",
    d: "M1.457 10.895c-.192-.108-.637-.26-1.128-1.346-.078-.172.07-.141.082-.139.371.077 1.652.34 1.746 1.43.021.243-.529.08-.7.055M2.423 7.731c-.304.11-.635.345-.572-.175.02-.17.134-1.12 1.448-1.588.162-.057-.129 1.265-.637 1.623-.018.013-.018.01-.24.14",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#9B8D52",
    fillRule: "evenodd",
    d: "M2.976 8.569c-.008.02-.155.94-1.076 1.17-.181.046-.297-.856.329-1.453.424-.405.852-.667.861-.595.022.175-.1.808-.114.878M5.646 12.79c.022.074.217.711.034.973-.164.234-1.297-.514-1.199-2.005.008-.113.325.13.35.15.643.493.638.58.815.881",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#B4A97D",
    fillRule: "evenodd",
    d: "M2.478 10.07c.073-.146.147-.4.662-.933.017-.018.262-.27.289-.122.304 1.743-.773 2.227-.884 2.138-.286-.23-.088-.998-.067-1.082",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#9B8D52",
    fillRule: "evenodd",
    d: "M.493 7.187C.464 7.103.267 6.524.256 6.1c-.003-.116.567.263.75.416.891.739.64 1.585.52 1.578C.906 8.06.54 7.287.493 7.187M5.473 2.734c-.082.037-.781.356-1.111.115-.033-.024-.032-.98 1.49-1.185.53-.072.552.001.531.039a3.15 3.15 0 0 1-.91 1.03",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#B4A97D",
    fillRule: "evenodd",
    d: "M2.648 4.587c-.286.378-.461.601-.643.163-.252-.609-.116-1.04.282-1.684.076-.124.303-.569.384-.265.328 1.24.154 1.343-.023 1.786",
    clipRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#9B8D52",
    fillRule: "evenodd",
    d: "M3.01 12.052c.033.117.152.325-.348.313-.165-.004-1.061-.027-1.686-1.182-.053-.098.637-.084 1.009.04.687.228.768.336 1.024.829",
    clipRule: "evenodd"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#B4A97D",
    fillRule: "evenodd",
    d: "M.575 7.86c.136.082.759.351.944 1.04.173.648-.094.592-.14.582C.423 9.283.179 8.402.015 7.77c-.025-.094-.027-.146.062-.113.04.015.037.015.498.203M4.187 11.956c-.117.203-.41 1.078-.799.036-.258-.689.402-2 .488-1.81.556 1.23.384 1.484.311 1.774",
    clipRule: "evenodd"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#9B8D52",
    fillRule: "evenodd",
    d: "M5.242 14.664c-.45.135-.495.182-1.416-.2 0 0-.634-.302-.49-.4.099-.067 1.012-.399 1.532-.223.07.024.612.207.758.52.074.157-.294.263-.384.303M2.15 5.782c.113-.302.188-.699.89-1.026.207-.098 1.01-.399.946-.232-.546 1.435-1.21 1.465-1.601 1.498-.346.03-.238-.145-.234-.24M6.19 14.706c-.648-.335.194-.895.384-.41.056.145-.019.273-.03.293-.116.196-.325.12-.354.117",
    clipRule: "evenodd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#9B8D52",
    d: "m7.787 12.37 3.424-4.392-3.617-4.544 4.545 3.617 4.392-3.424-3.424 4.392 3.617 4.545-4.544-3.617z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#9B8D52",
    fillRule: "evenodd",
    d: "M22.447 6.22c.106.28.162.67.563.232.686-.748.15-2.164.114-2.154 0 0-.668.767-.73 1.374-.028.28-.002.275.053.549",
    clipRule: "evenodd"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#B4A97D",
    fillRule: "evenodd",
    d: "M19.71 4.1c.062.028.562.363 1.193.119.05-.02.287-.112-.233-.638-.505-.51-1.864-.47-1.84-.371.07.298.8.831.88.89M21.361 13.512c.027-.013.386-.128.959-.616.25-.213-.879-.275-.959-.28-.912-.05-1.432.726-1.302.79.736.362 1.148.145 1.302.106",
    clipRule: "evenodd"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#9B8D52",
    fillRule: "evenodd",
    d: "M20.185 2.692c.055.106.163.507.78.776.128.055.485-.742-.203-1.61-.044-.055-.623-.785-.665-.59-.133.612.058 1.313.088 1.424",
    clipRule: "evenodd"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#B4A97D",
    fillRule: "evenodd",
    d: "M22.863 10.895c.192-.108.637-.26 1.128-1.346.078-.172-.07-.141-.082-.139-.37.077-1.652.34-1.746 1.43-.021.243.53.08.7.055M21.898 7.731c.303.11.634.345.572-.175-.02-.17-.134-1.12-1.449-1.588-.161-.057.129 1.265.637 1.623.018.013.018.01.24.14",
    clipRule: "evenodd"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#9B8D52",
    fillRule: "evenodd",
    d: "M21.345 8.569c.007.02.154.94 1.075 1.17.182.046.297-.856-.329-1.453-.424-.405-.852-.667-.86-.595-.023.175.1.808.114.878M18.675 12.79c-.023.074-.218.711-.035.973.164.234 1.298-.514 1.199-2.005-.008-.113-.325.13-.35.15-.643.493-.637.58-.814.881",
    clipRule: "evenodd"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#B4A97D",
    fillRule: "evenodd",
    d: "M21.842 10.07c-.072-.146-.147-.4-.662-.933-.017-.018-.262-.27-.288-.122-.305 1.743.773 2.227.884 2.138.285-.23.088-.998.066-1.082",
    clipRule: "evenodd"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#9B8D52",
    fillRule: "evenodd",
    d: "M23.827 7.187c.029-.084.226-.663.237-1.087.003-.116-.566.263-.75.416-.89.739-.64 1.585-.52 1.578.62-.034.986-.807 1.033-.907M18.848 2.734c.08.037.78.356 1.11.115.033-.024.032-.98-1.49-1.185-.53-.072-.552.001-.531.039.344.627.821.967.91 1.03",
    clipRule: "evenodd"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#B4A97D",
    fillRule: "evenodd",
    d: "M21.673 4.587c.285.378.46.601.642.163.252-.609.116-1.04-.282-1.684-.076-.124-.303-.569-.383-.265-.329 1.24-.155 1.343.023 1.786",
    clipRule: "evenodd"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#9B8D52",
    fillRule: "evenodd",
    d: "M21.311 12.052c-.033.117-.153.325.348.313.164-.004 1.06-.027 1.685-1.182.053-.098-.636-.084-1.009.04-.687.228-.768.336-1.024.829",
    clipRule: "evenodd"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#B4A97D",
    fillRule: "evenodd",
    d: "M23.746 7.86c-.137.082-.76.351-.944 1.04-.174.648.093.592.14.582.955-.199 1.2-1.08 1.364-1.713.024-.094.026-.146-.063-.113-.04.015-.037.015-.497.203M20.133 11.956c.117.203.41 1.078.8.036.257-.689-.403-2-.49-1.81-.555 1.23-.382 1.484-.31 1.774",
    clipRule: "evenodd"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#9B8D52",
    fillRule: "evenodd",
    d: "M19.079 14.664c.45.135.495.182 1.415-.2.001 0 .634-.302.49-.4-.098-.067-1.012-.399-1.532-.223-.07.024-.612.207-.758.52-.073.157.295.263.385.303M22.17 5.782c-.113-.302-.188-.699-.89-1.026-.207-.098-1.01-.399-.946-.232.547 1.435 1.21 1.465 1.602 1.498.346.03.237-.145.234-.24M18.13 14.706c.648-.335-.194-.895-.383-.41-.057.145.018.273.03.293.115.196.324.12.353.117",
    clipRule: "evenodd"
  })));
};
export default SvgLaurelsStar;